import http from "../../app/utils/http";
import {getQueryParams} from "../../app/utils/requestUtils";

export const PATIENTS_URL = "patients";

export const getPatients = (data,cancelToken) => http.get(`${PATIENTS_URL}${getQueryParams(data)}`, { ...(cancelToken? {cancelToken: cancelToken.token} : {}) })
export const getPatient = (id) => http.get(`${PATIENTS_URL}/${id}`)
